import { useEffect } from "react";
import { useSelector } from "react-redux";
import DashboardPage from "./components/pages/DashboardPage";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import './index.css';
import StudentPage from "./components/StudentDashboard/StudentPage";
import { setupAxiosInterceptors } from "./common/utils/axiosConfig";
import ProtectedRoute from "./components/features/common/ProtectedRoute";
import useSessionTimeout from "./components/hooks/useSessionTimeout";
import useSessionMonitor from "./components/hooks/useSessionMonitor";
import { STUDENT_ROUTE, ADMIN_ROUTE, LAST_DASHBOARD_KEY } from "./common/constants/routeConstants";

function SessionTimeoutManager() {
  useSessionTimeout(60);
  return null;
}

function SessionMonitor() {
  useSessionMonitor();
  return null;
}

function AdminRoute() {
  const navigate = useNavigate();
  const studentLoggedIn = useSelector((state) => state.login.student?.isLoggedIn);

  useEffect(() => {
    const lastDashboard = sessionStorage.getItem(LAST_DASHBOARD_KEY);
    if (lastDashboard === STUDENT_ROUTE && studentLoggedIn) {
      navigate(STUDENT_ROUTE, { replace: true });
    }
  }, [navigate, studentLoggedIn]);

  return (
    <ProtectedRoute redirectTo={ADMIN_ROUTE} requiredRole="admin">
      <DashboardPage />
    </ProtectedRoute>
  );
}

function StudentRoute() {
  const navigate = useNavigate();
  const adminLoggedIn = useSelector((state) => state.login.admin?.isLoggedIn);

  useEffect(() => {
    const lastDashboard = sessionStorage.getItem(LAST_DASHBOARD_KEY);
    if (lastDashboard === ADMIN_ROUTE && adminLoggedIn) {
      navigate(ADMIN_ROUTE, { replace: true });
    }
  }, [navigate, adminLoggedIn]);

  return (
    <ProtectedRoute redirectTo={STUDENT_ROUTE} requiredRole="student">
      <StudentPage />
    </ProtectedRoute>
  );
}

function AppContent() {
  const location = useLocation();
  const adminLoggedIn = useSelector((state) => state.login.admin?.isLoggedIn);
  const studentLoggedIn = useSelector((state) => state.login.student?.isLoggedIn);

  useEffect(() => {
    setupAxiosInterceptors();
  }, []);

  useEffect(() => {
    if (location.pathname === ADMIN_ROUTE && adminLoggedIn) {
      sessionStorage.setItem(LAST_DASHBOARD_KEY, ADMIN_ROUTE);
    } else if (location.pathname === STUDENT_ROUTE && studentLoggedIn) {
      sessionStorage.setItem(LAST_DASHBOARD_KEY, STUDENT_ROUTE);
    }
  }, [location.pathname, adminLoggedIn, studentLoggedIn]);

  return (
    <>
      <SessionTimeoutManager />
      <SessionMonitor />
      <Routes>
        <Route path="/" element={<Navigate to={ADMIN_ROUTE} replace />} />
        <Route path={ADMIN_ROUTE} element={<AdminRoute />} />
        <Route path={STUDENT_ROUTE} element={<StudentRoute />} />
        <Route path="*" element={<Navigate to={ADMIN_ROUTE} replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
